export enum DocumentsActionsIcon {
    DOWNLOAD_ICON = 'download',
    DELETE_ICON = 'trash-2',
    SHARE_ICON = 'share-2',
}
